<template>
  <div>
    <el-card
      class="text-left"
      :body-style="{padding:'10px'}"
      shadow="never"
    >
      <div slot="header">
        <el-popover trigger="click" :content="info.title" placement="top-start">
          <h4 slot="reference" class="text-nowrap">{{info.title}}</h4>
        </el-popover>
      </div>
      <div class="help-text text-nowrap">关注关键字：{{info.includeWords}}</div>
      <div class="help-text text-nowrap">是否接收日报推送：{{info.receiveDailyReport | fmtBoolean}}</div>
      <div class="help-text text-nowrap">接收时间段：{{info.receiveStart}} ~ {{info.receiveEnd}}</div>
      <div class="help-text text-nowrap" v-if="info.excludeWords">排除关键字：{{info.excludeWords}}</div>
      <div class="help-text text-nowrap" v-if="info.includeAreas">关注地区：{{info.includeAreas}}</div>
      <div class="help-text text-nowrap" v-if="info.excludeAreas">排除地区：{{info.excludeAreas}}</div>
      <div class="help-text text-nowrap" v-if="info.includeCompany">关注公司：{{info.includeCompany}}</div>
      <div class="help-text text-nowrap" v-if="info.excludeCompany">排除公司：{{info.excludeCompany}}</div>
      <div class="help-text">创建时间：{{info.createDate}}</div>
      <div class="text-right">
        <el-button
          type="text"
          icon="el-icon-edit"
          @click="edit(info)"
          size="mini"
        >编辑</el-button>&nbsp;&nbsp;&nbsp;&nbsp;
        <el-popconfirm
          @confirm="remove(info)"
          :title="'您确定要删除 ' + info.title + ' 信息吗？'"
        >
          <el-button
            slot="reference"
            type="text"
            icon="el-icon-remove"
            size="mini"
          >删除</el-button>
        </el-popconfirm>
      </div>
    </el-card>
  </div>
</template>
<script>

import ConcernedInfo from '@/models/ConcernedInfo'

export default {
    props: {
        info: ConcernedInfo
    },
    methods: {
        edit (i) {
          this.$emit('edit', new ConcernedInfo(i))
        },
        remove() {
          this.$emit('remove', new ConcernedInfo(this.info))
        }
    }
}
</script>
<style scoped>
</style>
